import React from "react";
import { InputNumber, Slider } from "antd";
import styled from "styled-components";

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const StyledInputNumber = styled(InputNumber)`
  width: 100px;
`;

const StyledSlider = styled(Slider)`
  flex: 1;
  .ant-slider-rail {
    background-color: #333;
  }
  .ant-slider-track {
    background-color: #1890ff;
  }
`;

interface NumberSetterProps {
  value?: number;
  onChange?: (value: number) => void;
  min?: number;
  max?: number;
  step?: number;
  variant?: 'input' | 'slider';
  display?: {
    components: ('input' | 'slider')[];
  };
}

export const NumberSetter: React.FC<NumberSetterProps> = ({
  value,
  onChange,
  min,
  max,
  step,
  variant,
  display,
}) => {
   // 如果有display配置，显示组件组合
   if (display?.components) {
    return (
      <Container>
        {display.components.includes('input') && (
          <StyledInputNumber
            value={value}
            onChange={onChange}
            min={min}
            max={max}
            step={step}
          />
        )}
        {display.components.includes('slider') && (
          <StyledSlider
            value={value}
            onChange={onChange}
            min={min}
            max={max}
            step={step}
          />
        )}
      </Container>
    );
  }
  // 如果有variant配置，显示对应组件
  if (variant === 'slider') {
    return (
      <StyledSlider
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        step={step}
      />
    );
  }

  // 默认显示input
  return (
    <StyledInputNumber
      value={value}
      onChange={onChange}
      min={min}
      max={max}
      step={step}
    />
  );
};
